import { useState } from 'react';

const faqs = [
  {
    question: '91网址导航与其他网址导航有何不同？',
    answer: '91网址导航注重精选与品质，每个收录的网站都经过人工审核与筛选，确保推荐的都是高质量、实用性强的优质站点。我们覆盖生活、娱乐、工具、学习等十大类别，满足不同用户的上网需求。同时，91网址还提供精选文章和效率工具推荐，帮助用户更好地利用互联网资源。',
  },
  {
    question: '如何将我的网站提交到91网址导航？',
    answer: '您可以通过"关于我们"页面的联系表单提交网站收录申请。我们的编辑团队会在3个工作日内对提交的网站进行审核，审核通过的网站将被收录到对应分类中。请确保提交的网站内容健康、功能正常、具有实用价值。',
  },
  {
    question: '91网址导航是免费的吗？',
    answer: '是的，91网址导航完全免费！我们的目标是为广大网友提供一个高效、纯净的上网入口，所有功能包括网址浏览、分类查看、文章阅读等都不需要任何费用。我们会持续更新和维护网站内容，确保用户获得最佳体验。',
  },
  {
    question: '如何快速找到我需要的网站？',
    answer: '您可以通过以下几种方式快速找到目标网站：1）使用首页顶部的搜索框输入网站名称或关键词；2）通过十大分类导航浏览对应类别的网站；3）在精选推荐中查看我们推荐的高品质网站。此外，您还可以将91网址设为浏览器主页，每次打开浏览器即可直达。',
  },
  {
    question: '91网址导航会收集我的个人隐私吗？',
    answer: '91网址导航非常重视用户隐私保护。我们不会收集用户的浏览记录、搜索历史等个人信息。网站仅使用必要的技术手段保证服务正常运行，具体请参阅我们的隐私政策。您的上网安全与隐私始终是我们最关注的事项。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">
            关于91网址导航的常见疑问解答
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
              >
                <span className="text-sm font-semibold text-foreground-900 pr-4 font-heading">
                  {faq.question}
                </span>
                <span
                  className={`w-5 h-5 flex-shrink-0 flex items-center justify-center transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                >
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </span>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}